import React from "react";
import styled from "styled-components";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import PropTypes from "prop-types";
import { Button } from "./Common";
import { TABLE_CONFIG } from "../constant";

const CustomizedButton = styled(Button)`
  padding: 0px 2px;
  margin-right: 10px;
  color: ${({ theme }) => theme.palette.SECONDARY};
  svg {
    font-size: 21px;
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

const getLastPageNumber = (currentPage, totalRecords) => {
  const pageNumber = currentPage * TABLE_CONFIG.ROWS;
  return pageNumber > totalRecords ? totalRecords : pageNumber;
};

const getFirstPageNumber = (currentPage, totalRecords) => {
  const firstPage = currentPage * TABLE_CONFIG.ROWS - TABLE_CONFIG.ROWS + 1;
  return firstPage > totalRecords ? totalRecords : firstPage;
};

export const PaginationComp = ({
  className,
  currentPage,
  totalRecords,
  movePrev,
  moveNext
}) => {
  const lastPage = Math.ceil(totalRecords / TABLE_CONFIG.ROWS);
  return (
    <div className={`${className} page-nav`}>
      <span className="pg-sp">Showing</span>
      <span className="pg-btn">
        {`${getFirstPageNumber(currentPage, totalRecords)} - ${
          totalRecords < TABLE_CONFIG.ROWS
            ? totalRecords
            : getLastPageNumber(currentPage, totalRecords)
        } `}
        <span className="light-clr">{`of ${totalRecords}`}</span>
      </span>
      <CustomizedButton disabled={currentPage < 2} onClick={movePrev}>
        <KeyboardArrowLeft />
      </CustomizedButton>
      <CustomizedButton
        disabled={currentPage === lastPage || currentPage > lastPage}
        onClick={moveNext}
      >
        <KeyboardArrowRight />
      </CustomizedButton>
    </div>
  );
};

PaginationComp.propTypes = {
  className: PropTypes.string,
  currentPage: PropTypes.number,
  totalRecords: PropTypes.number,
  movePrev: PropTypes.func,
  moveNext: PropTypes.func
};

PaginationComp.defaultProps = {
  className: "",
  currentPage: 1,
  totalRecords: 20,
  movePrev: () => {},
  moveNext: () => {}
};

export const Pagination = styled(PaginationComp)`
  &.page-nav {
    display: flex;
    justify-content: flex-end;
    font-size: ${/* istanbul ignore next */ ({ theme }) =>
      theme.fontSize.SMALL};
  }
  .pg-btn {
    border: solid 1px
      ${/* istanbul ignore next */ ({ theme }) => theme.palette.LIGHTGREY1};
    background-color: ${/* istanbul ignore next */ ({ theme }) => {
      return theme.palette.LIGHTGREY3;
    }};
    border-radius: 4px;
    padding: 5px 5px;
    margin-right: 20px;
    padding-left: 10px;
    padding-right: 10px;
    min-width: 110px;
    text-align: center;
  }
  .pg-sp {
    padding: 5px;
  }
  .light-clr {
    color: ${/* istanbul ignore next */ ({ theme }) => {
      return theme.palette.DARKGREY2;
    }};
  }
`;
